<template>
  <div>
    <a-form :model="searchForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="链接名称">
            <a-input v-model="searchForm.title" allowClear placeholder="请输入链接名称" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select v-model="searchForm.line_id" allowClear show-search option-filter-prop="children" placeholder="请选择发布平台" style="width: 100%">
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="排序">
            <a-select v-model="searchForm.sort" allowClear show-search option-filter-prop="children" placeholder="请选择排序" style="width: 100%">
              <a-select-option v-for="item in LINKS_SORT" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="状态">
            <a-select v-model="searchForm.status" allowClear show-search option-filter-prop="children" placeholder="请选择状态" style="width: 100%">
              <a-select-option v-for="item in LINKS_STATUS" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布时间">
            <v-range-picker v-model="times" :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="handleAdd">添加链接</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right:10px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </div>

    <!-- 表格 -->
    <a-table size="middle" row-key="id" :columns="columns" :loading="loading" :data-source="data" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <!-- <template slot="org" slot-scope="text">
        <a-tag color="blue">{{ text }}</a-tag>
      </template> -->
      <template slot="sort" slot-scope="text, record">
        <a-input-number v-model="record.sort" :min="0" @blur="inputDebounce(text, record)" />
      </template>
      <template slot="show_position" slot-scope="text">
        <!-- <a-space> -->
        <span class="link-position" v-for="item in text" :key="item">{{ showName('LINKS_SHOW_POSITION', item) }}</span>
        <!-- </a-space> -->
      </template>
      <template slot="url" slot-scope="text">
        <a :href="text" target="_blank">{{ text }}</a>
      </template>
      <template slot="status" slot-scope="text">
        <span v-if="text === 1" color="green">{{ showName('LINKS_STATUS', text) }}</span>
        <span v-else style="color:red;">{{ showName('LINKS_STATUS', text) }}</span>
      </template>
      <template slot="operator" slot-scope="text, record">
        <div class="flex-sb">
          <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
          <a-button size="small" type="link" @click="handleTableCommand('delete',record)">删除</a-button>
        </div>
      </template>
    </a-table>

    <!-- 添加分类 -->
    <AddLink v-model="visible" :isEdit="isEdit" :params="waitItem" :platformList="platformList" @handleOver="getList" />
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { searchForm, columns, form } from './business/linkList'
import { strategyCommand } from './business/tableList'
import pagination from '@/composables/pagination'
import AddLink from './components/AddLink'
import compuedFun from './computed/'
import api from '@/api/'

export default {
  components: { AddLink },
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      times: [],
      platformList: [],
      searchForm: { ...searchForm }
    })

    onMounted(async () => {
      await methods.getPlatform()
      methods.getList()
    })

    const methods = {
      search() {
        _this.pagination.current = 1
        this.getList()
      },

      async getList() {
        _this.loading = true
        state.searchForm.start_time = state.times[0]
        state.searchForm.end_time = state.times[1]
        const res = await api.listLink({
          ..._this.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        const { links, pagination } = res.data
        _this.data = links
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data
      },

      async inputDebounce(sort, data) {
        const res = await api.updateLink(data)
        if (_this.$validate(res)) {
          _this.$message.success('操作成功~')
        }
      },

      // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },

      handleClear() {
        state.searchForm = { ...searchForm }
        state.times = []
        this.search()
      },
      handleAdd() {
        _this.visible = true
        _this.isEdit = false
      }
    }

    return {
      ...toRefs(state),
      ...compuedFun(),
      ...pagination(),
      ...methods
    }
  }
}
</script>
<style scoped>
.link-position {
  display: inline-block;
  margin-right: 16px;
}
</style>
